import React from "react";

const UploadState = ({ state, termId }) => {
    const flaggedDeniedStates = [5, 6, 2, 7];

    if (state === 3 || termId) {
        return <span className="ui_approve" />;
    }

    if (flaggedDeniedStates.indexOf(state) > -1) {
        return <span className="ui_close" />;
    }

    return null;
};

const ActiveUpload = ({ upload }) => {
    return (
        <li className="icon-card icon" data-state={upload.uploadState}>
            <div className="icon-card-inner">
                <span className="icon-meta">
                    {upload.countDownload} downloads
                </span>
                <a href={upload.permalink}>
                    <img src={upload.previewUrl} alt={`${upload.term} Icon`} />
                </a>
                <div className="icon-info">
                    <UploadState
                        state={upload.uploadState}
                        termId={upload.termId}
                    />
                    <button
                        type="button"
                        className="more-information ui_information"
                        data-icon-id={upload.id}
                        data-url={`${upload.uploader.permalink}/icon/${
                            upload.id
                        }/information`}
                    />
                </div>
            </div>
        </li>
    );
};

export default ActiveUpload;
